// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Project_bg-img__Nu3p6 {
  background-color: #191A1A;
  background-image: url("https://i.imgur.com/O6tgsUu.png");
  background-size: cover;
  background-position: center;
}

.Project_project-container-one__yX1Gw {
  width: 100%;
  height: 80vh;
  background-image: url("https://i.imgur.com/0iVcmHY.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

.Project_carousel-wrapper__Vz\\+dt {
  width: 90%;
  margin: auto;
  position: relative;
  padding: 0 50px;
}

.Project_carousel__2zOUk {
  width: 100%;
}

.Project_carousel-item__6zD2X {
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.Project_carousel-img__uN4Da {
  width: 100%;
  height: 650px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.Project_carousel-btn-left__fKa5o,
.Project_carousel-btn-right__c3DHp {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: #969595;
  border: 1px solid gray;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.Project_carousel-btn-left__fKa5o {
  left: 0;
}

.Project_carousel-btn-right__c3DHp {
  right: 0;
}

.Project_h1__bBMmF {
  height: 100%;
  width: 100%;
  color: white;
  font-size: 54px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  padding-top: 80px;
  padding-left: 230px;
  margin-bottom: 80px;
}

.Project_images-section__jWPP6 {
  width: 100%;
  margin: auto;
  height: 60vh;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.Project_img-wind__qu6za {
  max-width: 500px;
  width: 100%;
  height: 400px;
  background-image: url("https://i.imgur.com/ds4uRLC.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 32px;
  margin-bottom: 50px;
  background-position-y: -90px;
}

.Project_img-wind-two__NvFnc {
  max-width: 500px;
  width: 100%;
  height: 400px;
  background-image: url("https://i.imgur.com/afRXiXf.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  border-radius: 32px;
  object-fit: contain;
  margin-left: 80px;
  margin-bottom: 50px;
}

.Project_img-wind-three__7CEjP {
  max-width: 500px;
  width: 100%;
  height: 400px;
  background-image: url("https://i.imgur.com/DhV8HmP.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  border-radius: 32px;
  object-fit: contain;
  margin-left: 80px;
  margin-top: -45px;
}

.Project_text-section__yv-lI {
  width: 100%;
  height: 70vh;
  margin-top: 350px;
}

.Project_text__MjYIV {
  width: 80%;
  height: 70%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  text-align: center;
  border-radius: 36px;
  margin-top: -380px;
}

.Project_text__MjYIV span {
  color: white;
  font-size: 26px;
  font-weight: 400;
  font-family: "Roboto", sans-serif;
  text-align: start;
  max-width: 400px;
  width: 100%;
  margin-top: 110px;
}

.Project_video-section__zoRfo {
  width: 100%;
  margin: auto;
}

.Project_video__lV6xw {
  width: 80%;
  margin: auto;
  height: 90%;
  border: 10px solid gray;
}

.Project_img-exo__i8kjT {
  max-width: 500px;
  width: 40%;
  height: 400px;
  background-image: url("https://i.imgur.com/97WLHvO.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-color: #252626;
  border-radius: 32px;
  background-position: center;
  margin-bottom: 50px;
  background-position-x: -20px;
}

.Project_img-exo-two__BWHrZ {
  max-width: 500px;
  width: 40%;
  height: 400px;
  background-image: url("https://i.imgur.com/dLVQMlZ.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-color: #252626;
  margin-left: 70px;
  border-radius: 32px;
  background-position: center;
  margin-bottom: 50px;
}

.Project_img-exo-three__DUDT6 {
  max-width: 500px;
  width: 40%;
  height: 400px;
  background-image: url("https://i.imgur.com/mxfvR4B.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-color: #252626;
  margin-left: 70px;
  border-radius: 32px;
  background-position: center;
  margin-top: -45px;
}

.Project_texts__7Zat\\+ {
  width: 80%;
  height: 70%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  text-align: center;
  border-radius: 36px;
}

.Project_texts__7Zat\\+ span {
  color: white;
  font-size: 20px;
  font-weight: 400;
  font-family: "Roboto", sans-serif;
  text-align: center;
  max-width: 800px;
  width: 100%;
  margin-top: 150px;
}

.Project_text-section-two__r803E {
  width: 100%;
  height: 70vh;
}

.Project_h2__7b\\+HK {
  height: 100%;
  color: white;
  font-size: 54px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  padding: 250px;
}

@media (max-width: 1024px) {
  .Project_text-section__yv-lI {
    margin-top: 300px;
    font-size: 17px;
  }
  .Project_h1__bBMmF {
    margin: 0;
    margin-bottom: 50px;
    padding: 0;
    padding-top: 30px;
    font-size: 18px;
    text-align: center;
  }
  .Project_h2__7b\\+HK {
    font-size: 22px;
  }
  .Project_carousel-img__uN4Da {
    height: 300px;
  }
  .Project_project-container-one__yX1Gw {
    height: 40vh;
  }
  .Project_img-wind__qu6za {
    margin: auto;
    margin-bottom: 40px;
    width: 250px;
    height: 250px;
  }
  .Project_img-wind-two__NvFnc {
    margin: auto;
    width: 250px;
    height: 250px;
    margin-bottom: 35px;
  }
  .Project_img-wind-three__7CEjP {
    margin: auto;
    width: 250px;
    height: 250px;
  }
  .Project_video-section__zoRfo {
    margin-top: -10px;
  }
  .Project_images-section__jWPP6 {
    display: block;
    margin: auto;
  }
  .Project_bg-img__Nu3p6 {
    background-image: url("https://i.imgur.com/xKBnSPm.png");
    background-size: contain;
  }
  .Project_img-exo__i8kjT {
    margin: auto;
    width: 250px;
    height: 250px;
  }
  .Project_img-exo-two__BWHrZ {
    margin: auto;
    width: 250px;
    height: 250px;
    margin-bottom: 35px;
  }
  .Project_img-exo-three__DUDT6 {
    margin: auto;
    width: 250px;
    height: 250px;
  }
  .Project_h1__bBMmF {
    font-size: 24px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  .Project_h2__7b\\+HK {
    font-size: 32px;
    padding: 50px;
  }
  .Project_text-section__yv-lI {
    height: 100%;
  }
  .Project_text__MjYIV {
    height: 100%;
    width: 300px;
  }
  .Project_span__2EKyA {
    font-size: 14px;
    padding: 30px;
    text-align: center;
  }
  .Project_text-section-two__r803E {
    height: 100%;
  }
  .Project_texts__7Zat\\+ {
    height: auto;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 300px;
  }
  .Project_video__lV6xw {
    margin-bottom: 220px;
  }
  .Project_text__MjYIV span {
    font-size: 18px;
  }
  .Project_text-section__yv-lI {
    padding-top: 40px;
  }
}
@media screen and (max-width: 720px) {
  .Project_text-section__yv-lI {
    margin-top: 100px;
    font-size: 17px;
  }
}
@media screen and (max-width: 520px) {
  .Project_text-section__yv-lI {
    margin-top: 10px;
    font-size: 17px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Project/Project.module.scss"],"names":[],"mappings":"AAQA;EACE,yBAAA;EACA,wDAAA;EACA,sBAAA;EACA,2BAAA;AAPF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;AARF;;AAYA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,wBAAA;EACA,uBAAA;EACA,mBAAA;AATF;;AAYA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,mBAAA;EACA,yCAAA;AAVF;;AAaA;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,0CAAA;AAVF;;AAaA;EACE,OAAA;AAVF;;AAaA;EACE,QAAA;AAVF;;AAaA;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAXF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EAGA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAfF;;AAoBA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EAGA,mBAAA;EACA,mBAAA;EACA,4BAAA;AAnBF;;AAuBA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,wDAAA;EACA,sBAAA;EAEA,4BAAA;EAEA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAtBF;;AA2BA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EAEA,4BAAA;EAEA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,YAAA;EAGA,iBAAA;AA5BF;;AAkCA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAhCF;;AAsCA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAnCF;;AAyCA;EACE,WAAA;EAGA,YAAA;AAxCF;;AA8CA;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AA3CF;;AAgDA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACA,wDAAA;EACA,wBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,4BAAA;AA9CF;;AAkDA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACA,wDAAA;EACA,wBAAA;EAEA,4BAAA;EAEA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAjDF;;AAqDA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACE,wDAAA;EACF,wBAAA;EAEA,4BAAA;EAEA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AApDF;;AAuDA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;AArDF;;AA0DA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAvDF;;AA2DA;EACE,WAAA;EACA,YAAA;AAxDF;;AAgEA;EAEE,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;AA9DF;;AAkEA;EAEE;IACE,iBAAA;IACA,eAAA;EAhEF;EAoEA;IACE,SAAA;IACA,mBAAA;IACA,UAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAlEF;EAsEA;IACE,eAAA;EApEF;EAsEA;IACE,aAAA;EApEF;EAuEA;IACE,YAAA;EArEF;EAyEA;IACE,YAAA;IACA,mBAAA;IACA,YAAA;IACA,aAAA;EAvEF;EA8EA;IACE,YAAA;IACA,YAAA;IACA,aAAA;IACJ,mBAAA;EA5EE;EAkFA;IACE,YAAA;IACA,YAAA;IACA,aAAA;EAhFF;EAkFE;IACA,iBAAA;EAhFF;EAuFA;IACE,cAAA;IACA,YAAA;EArFF;EAyFF;IAEA,wDAAA;IACE,wBAAA;EAxFA;EA0FA;IACE,YAAA;IAEA,YAAA;IACA,aAAA;EAzFF;EA4FA;IACE,YAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;EA1FF;EA8FA;IACE,YAAA;IACA,YAAA;IACA,aAAA;EA5FF;EA0GA;IACE,eAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,uBAAA;EAxGF;EA2GA;IACE,eAAA;IACA,aAAA;EAzGF;EA2GA;IACE,YAAA;EAzGF;EA4GA;IACE,YAAA;IACA,YAAA;EA1GF;EA4GA;IACE,eAAA;IACA,aAAA;IACA,kBAAA;EA1GF;EA8GA;IACE,YAAA;EA5GF;EA+GA;IACE,YAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;IACA,YAAA;EA7GF;EAgHA;IAEE,oBAAA;EA/GF;EAmHA;IACE,eAAA;EAjHF;EAqHA;IACE,iBAAA;EAnHF;AACF;AAsHA;EACE;IACE,iBAAA;IACA,eAAA;EApHF;AACF;AAuHA;EACE;IACE,gBAAA;IACA,eAAA;EArHF;AACF","sourcesContent":["//.bg-img{\n//width: 100%;\n//  height: 300vh;\n//  background-color: red ;\n//  z-index: 99;\n//  position: absolute;\n//}\n\n.bg-img{\n  background-color: #191A1A;\n  background-image: url(\"https://i.imgur.com/O6tgsUu.png\");\n  background-size: cover;\n  background-position: center;\n  //position: relative;\n  //z-index: 99;\n}\n.project-container-one {\n  width: 100%;\n  height: 80vh;\n  background-image: url(\"https://i.imgur.com/0iVcmHY.jpeg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n\n.carousel-wrapper {\n  width: 90%;\n  margin: auto;\n  position: relative;\n  padding: 0 50px; // space for side buttons\n}\n\n.carousel {\n  width: 100%;\n}\n\n.carousel-item {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n\n.carousel-img {\n  width: 100%;\n  height: 650px;\n  object-fit: cover;\n\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.carousel-btn-left,\n.carousel-btn-right {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 10;\n  background: #969595;\n  border: 1px solid gray;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n}\n\n.carousel-btn-left {\n  left: 0;\n}\n\n.carousel-btn-right {\n  right: 0;\n}\n\n.h1 {\n  //background-color: #191A1A;\n  height: 100%;\n  width: 100%;\n  color: white;\n  font-size: 54px;\n  font-weight: 700;\n  font-family: 'Roboto', sans-serif;\n  padding-top: 80px;\n  padding-left: 230px;\n  margin-bottom: 80px;\n  //margin-top: -4px;\n\n}\n\n.images-section {\n  width: 100%;\n  margin: auto;\n  height: 60vh;\n  height: 100%;\n  //background-color: #191A1A;\n  //margin-top: -55px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n\n\n}\n\n.img-wind {\n  max-width: 500px;\n  width: 100%;\n  height: 400px;\n  background-image: url(\"https://i.imgur.com/ds4uRLC.jpeg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  //background-color: #252626;\n  //background-color: #252626;\n  border-radius: 32px;\n  margin-bottom: 50px;\n  background-position-y: -90px;\n  //background-position-y: 25px;\n}\n\n.img-wind-two {\n  max-width: 500px;\n  width: 100%;\n  height: 400px;\n  background-image: url(\"https://i.imgur.com/afRXiXf.png\");\n  background-size: cover;\n  //background-color: #252626;\n  background-repeat: no-repeat;\n  //background-position-x: 200px;\n  overflow: hidden;\n  border-radius: 32px;\n  object-fit: contain;\n  margin-left: 80px;\n  margin-bottom: 50px;\n\n\n}\n\n.img-wind-three{\n  max-width: 500px;\n  width: 100%;\n  height: 400px;\n  background-image: url(\"https://i.imgur.com/DhV8HmP.jpeg\");\n  background-size: cover;\n  //background-color: #252626;\n  background-repeat: no-repeat;\n  //background-position-x: 200px;\n  overflow: hidden;\n  border-radius: 32px;\n  object-fit: contain;\n  margin-left: 80px;\n  margin-top: -45px;\n}\n\n.text-section {\n  width: 100%;\n  height: 70vh;\n  //height: 100%;\n  //background-color: #191A1A;\n  margin-top: 350px;\n  //margin-top: -4px;\n\n\n}\n\n.text {\n  width: 80%;\n  height: 70%;\n  margin: auto;\n  //background-color: #4C6D59;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  text-align: center;\n  border-radius: 36px;\n  margin-top: -380px;\n\n  //flex-direction: revert;\n\n}\n\n.text span {\n  color: white;\n  font-size: 26px;\n  font-weight: 400;\n  font-family: 'Roboto', sans-serif;\n  text-align: start;\n  max-width: 400px;\n  width: 100%;\n  margin-top: 110px;\n  //padding: 150px;\n\n}\n\n\n.video-section {\n  width: 100%;\n  //margin-top: -2px;\n  //padding-top: 70px;\n  margin: auto;\n\n  //height: 90vh;\n  //background-color: #191A1A;\n}\n\n.video {\n  width: 80%;\n  margin: auto;\n  height: 90%;\n  border: 10px solid gray;\n  //margin-bottom: 400px;\n}\n\n\n.img-exo {\n  max-width: 500px;\n  width: 40%;\n  height: 400px;\n  background-image: url(\"https://i.imgur.com/97WLHvO.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  //background-color: #252626;\n  background-color: #252626;\n  border-radius: 32px;\n  background-position: center;\n  margin-bottom: 50px;\n  background-position-x: -20px;\n\n}\n\n.img-exo-two {\n  max-width: 500px;\n  width: 40%;\n  height: 400px;\n  background-image: url(\"https://i.imgur.com/dLVQMlZ.png\");\n  background-size: contain;\n  //background-color: #252626;\n  background-repeat: no-repeat;\n  //background-position-x: 300px;\n  background-color: #252626;\n  margin-left: 70px;\n  border-radius: 32px;\n  background-position: center;\n  margin-bottom: 50px;\n\n\n}\n.img-exo-three{\n  max-width: 500px;\n  width: 40%;\n  height: 400px;\n    background-image: url(\"https://i.imgur.com/mxfvR4B.png\");\n  background-size: contain;\n  //background-color: #252626;\n  background-repeat: no-repeat;\n  //background-position-x: 300px;\n  background-color: #252626;\n  margin-left: 70px;\n  border-radius: 32px;\n  background-position: center;\n  margin-top: -45px;\n}\n\n.texts {\n  width: 80%;\n  height: 70%;\n  margin: auto;\n  //background-color: #4C6D59;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  text-align: center;\n  border-radius: 36px;\n\n\n}\n\n.texts span {\n  color: white;\n  font-size: 20px;\n  font-weight: 400;\n  font-family: 'Roboto', sans-serif;\n  text-align: center;\n  max-width: 800px;\n  width: 100%;\n  margin-top: 150px;\n\n}\n\n.text-section-two {\n  width: 100%;\n  height: 70vh;\n  //height: 100%;\n  //background-color: #191A1A;\n  //padding-top: 90px;\n  //margin-top: -4px;\n  //margin-bottom: 100px;\n}\n\n.h2 {\n  //background-color: #191A1A;\n  height: 100%;\n  color: white;\n  font-size: 54px;\n  font-weight: 700;\n  font-family: 'Roboto', sans-serif;\n  padding: 250px;\n\n}\n\n@media (max-width: 1024px) {\n\n  .text-section{\n    margin-top: 300px;\n    font-size: 17px;\n  }\n\n\n  .h1{\n    margin: 0;\n    margin-bottom: 50px;\n    padding: 0;\n    padding-top: 30px;\n    font-size: 18px;\n    text-align: center;\n\n  }\n\n  .h2{\n    font-size: 22px;\n  }\n  .carousel-img{\n    height: 300px;\n  }\n\n  .project-container-one {\n    height: 40vh;\n  }\n\n\n  .img-wind {\n    margin: auto;\n    margin-bottom: 40px;\n    width: 250px;\n    height: 250px;\n\n\n  }\n\n\n\n  .img-wind-two {\n    margin: auto;\n    width: 250px;\n    height: 250px;\nmargin-bottom: 35px;\n    //background-position-x: 60px;\n    //background-position-y: -20px;\n\n  }\n\n  .img-wind-three {\n    margin: auto;\n    width: 250px;\n    height: 250px;\n  }\n    .video-section {\n    margin-top: -10px;\n  }\n\n  .project-container-one {\n    //display: block;\n  }\n\n  .images-section {\n    display: block;\n    margin: auto;\n    //margin-top: -50px;\n\n  }\n.bg-img{\n  //background-size: contain;\nbackground-image: url(\"https://i.imgur.com/xKBnSPm.png\");\n  background-size: contain;\n}\n  .img-exo {\n    margin: auto;\n    //margin-bottom: 40px;\n    width: 250px;\n    height: 250px;\n  }\n\n  .img-exo-two {\n    margin: auto;\n    width: 250px;\n    height: 250px;\n    margin-bottom: 35px;\n\n\n  }\n  .img-exo-three {\n    margin: auto;\n    width: 250px;\n    height: 250px;\n\n\n\n  }\n  .video-section {\n    //margin-top: -10px;\n\n  }\n\n  .text-section {\n    //margin-top: -8px;\n\n  }\n  .h1 {\n    font-size: 24px;\n    display: flex;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n\n  }\n  .h2 {\n    font-size: 32px;\n    padding: 50px;\n  }\n  .text-section {\n    height: 100%;\n  }\n\n  .text {\n    height: 100%;\n    width: 300px;\n  }\n  .span {\n    font-size: 14px;\n    padding: 30px;\n    text-align: center;\n\n  }\n\n  .text-section-two {\n    height: 100%;\n    //margin-top: -10px;\n  }\n  .texts {\n    height: auto;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    width: 300px;\n\n  }\n  .video {\n    //height: 50vh;\n    margin-bottom: 220px;\n  }\n\n\n  .text span{\n    font-size: 18px;\n\n  }\n\n  .text-section{\n    padding-top: 40px;\n  }\n}\n\n@media screen and (max-width: 720px) {\n  .text-section{\n    margin-top: 100px;\n    font-size: 17px;\n  }\n}\n\n@media screen and (max-width: 520px) {\n  .text-section{\n    margin-top: 10px;\n    font-size: 17px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg-img": `Project_bg-img__Nu3p6`,
	"project-container-one": `Project_project-container-one__yX1Gw`,
	"carousel-wrapper": `Project_carousel-wrapper__Vz+dt`,
	"carousel": `Project_carousel__2zOUk`,
	"carousel-item": `Project_carousel-item__6zD2X`,
	"carousel-img": `Project_carousel-img__uN4Da`,
	"carousel-btn-left": `Project_carousel-btn-left__fKa5o`,
	"carousel-btn-right": `Project_carousel-btn-right__c3DHp`,
	"h1": `Project_h1__bBMmF`,
	"images-section": `Project_images-section__jWPP6`,
	"img-wind": `Project_img-wind__qu6za`,
	"img-wind-two": `Project_img-wind-two__NvFnc`,
	"img-wind-three": `Project_img-wind-three__7CEjP`,
	"text-section": `Project_text-section__yv-lI`,
	"text": `Project_text__MjYIV`,
	"video-section": `Project_video-section__zoRfo`,
	"video": `Project_video__lV6xw`,
	"img-exo": `Project_img-exo__i8kjT`,
	"img-exo-two": `Project_img-exo-two__BWHrZ`,
	"img-exo-three": `Project_img-exo-three__DUDT6`,
	"texts": `Project_texts__7Zat+`,
	"text-section-two": `Project_text-section-two__r803E`,
	"h2": `Project_h2__7b+HK`,
	"span": `Project_span__2EKyA`
};
export default ___CSS_LOADER_EXPORT___;
